import { useContext } from 'react';
import { Button } from '@givebutter/primitives/button';
import { faArrowRight } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as LetterEasySendCTADialog from 'assets/js/pages/engage/letters/LetterEasySendCTADialog';
import { useLetterMeta } from 'assets/js/pages/engage/letters/useLetterMeta';
import { StepperContext } from 'components/stepper';

const LetterFlowNextButton = () => {
    const { goForward, isOnLastStep } = useContext(StepperContext);
    const { isOnEditor, isEasySend } = useLetterMeta();
    const isCta = isOnEditor && !isEasySend;

    if (isOnLastStep) {
        return null;
    }

    if (!isCta) {
        return (
            <Button variant="solid" onClick={goForward} size="sm">
                <p className="sr-only sm:not-sr-only">Next</p>
                <FontAwesomeIcon icon={faArrowRight} />
            </Button>
        );
    }

    return (
        <LetterEasySendCTADialog.Root>
            <LetterEasySendCTADialog.Trigger asChild>
                <Button variant="solid" size="sm">
                    <p className="sr-only sm:not-sr-only">Next</p>
                    <FontAwesomeIcon icon={faArrowRight} />
                </Button>
            </LetterEasySendCTADialog.Trigger>
        </LetterEasySendCTADialog.Root>
    );
};

export { LetterFlowNextButton };
